module.exports = __webpack_public_path__ + "img/Vincent Chung, Co-Director of SIF, Schulich Finance Association.c0091319.webp";